// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

require("component-responsive-frame/child");
var $ = require("./lib/qsa");

var search_bar = document.querySelector("#search-bar"),
  county_selector = document.querySelector("#county-selector");

var search = function() {
  var input, filter, table, tr, td, i, txtValue;
  input = document.getElementById("search-bar");
  filter = input.value.toUpperCase();
  table = document.getElementById("table");
  tr = table.getElementsByClassName("facility-row");

  // Loop through all table rows, and hide those who don't match the search query
  for (i = 0; i < tr.length; i++) {
    td = tr[i].getElementsByTagName("td")[0];
    if (td) {
      txtValue = td.textContent || td.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        tr[i].style.display = "";
      } else {
        tr[i].style.display = "none";
      }
    }
  }
}

var filter_by_county = function(county) {
  var table = table = document.getElementById("table");
  var tr = table.getElementsByClassName("facility-row");

  for (i = 0; i < tr.length; i++) {
    if (county === "") {
      tr[i].style.display = "";
    } else if (tr[i].dataset.county === county) {
      tr[i].style.display = "";
    } else {
      tr[i].style.display = "none";
    }
  }
}

county_selector.addEventListener('change', function(e) {
  e.preventDefault();

  var val = county_selector.value;
  filter_by_county(val);
});

search_bar.addEventListener("keyup", search);